<template>
  <div class="modal" @click="currImg">
    <div class="image" :style="`background-image: url('${currentImage}'); background-position: center; background-size: cover;`"></div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'modal',
  computed:{
    ...mapState({
      currentImage: state=>state.realisations.currentImage
    })
  },
  methods:{
    ...mapMutations(['currImg'])
  }

}
</script>

<style scoped lang="scss">
  .modal{
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.616);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1999;
    position: fixed;
    top: 0;
    left: 0;
  }
  .image{
    width: 320px;
    height: 300px
  }
  @media (min-width: 1440px){
    .image{
      width: 1200px;
      height: 900px;
    }
  }
</style>